import ViewUtil from "../../../ViewUtil";
import CheckoutController from "../../../controllers/CheckoutController";
import GetdelinkQuery from "../../../queries/DelinkQueryExecutor";
import { ArchiveQuery } from "../../../queries/archive-restore/ArchiveQuery";
import { RestoreQuery } from "../../../queries/archive-restore/RestoreQuery";
import { favAddRemoveOperation, removeFavItem } from "../../../queries/fav/FavoriteUtil";
import CollectionUtil from "../../../queries/lightbox/CollectionUtil";
import LockQuery from "../../../queries/lock/LockQuery";
import UnLockQuery from "../../../queries/lock/UnLockQuery";
import ResurrectQuery from "../../../queries/resurrect/ResurrectQuery";
import { TMP_SELECTED_ASSETS_ID, COLLECTION_ID } from "../../../store/Constants";
import Store from "../../../store/Store";
import { ClipBoardUtil } from "../../../util/ClipBoardUtil";
import { BACK_TO_BTN } from "../../../util/Constants";
import FileInfoUtil from "../../../util/FileInfoUtil";
import { setBackToSrchBtn } from "../../../util/LocalStorageUtil";
import NativeActionUtil from "../../../util/NativeActionUtil";
import ParamsUtil from "../../../util/ParamsUtil";
import { filterAssets } from "../../../util/SelectedItemUtil";
import { DATA_CM } from "./util_CM";
import { treeEmitter } from "../../../tabs/collections/CollectionsTree";
import { toast } from "../../../store/StoreUtil";
import ErrorHandler from "../../../error/ErrorHandler";
import t from "../../../i18n/I18n";
import { isMobile } from "../../../util/ScreenUtil";
export const CM_ACTIONS = {
  onSetModalAction: (event, args) => {
    args.setModal(DATA_CM.PORTALS[args.action].MODAL)
  },

  OnEditMetadata: (event, args) => {
    const { assets, setShowInfoMetadata } = args;
    if (assets.length > 1) {
      CM_ACTIONS.onSetModalAction(event, args);
    } else {
      Store.put(TMP_SELECTED_ASSETS_ID, [assets[0].getFuid()]);
      setShowInfoMetadata(true);
    }
  },

  onRefresh: (event, args) => {
    args.onRefresh(args.extDetails);
  },
  onCopyAssetURL: (event, args) => {
    const asset = args.assets[0];
    const __url = ParamsUtil.generateWebclientURL(asset);
    ClipBoardUtil.copyToClipBoard(__url);
  },
  onCopyAssetPath: (event, args) => {
    const assets: Array<RepoItem> = args.assets;
    const items = [];
    assets.forEach((repo) => {
      items.push(repo.getRemotePath());
    });
    const text = items.join(', ');
    ClipBoardUtil.copyToClipBoard(text);
  },
  onCopyAssetId: (event, args) => {
    const text = ClipBoardUtil.extractAssetIDs(args.assets);
    ClipBoardUtil.copyToClipBoard(text);
  },
  onShowOnLegacyBrowser: (event, args) => {
    const assets: Array<RepoItem> = args.assets;
    NativeActionUtil.runExecQuery(null, 'asset_browser', undefined, assets[0].getFuid());
  },
  onRunRevealExecQuery: (event, args) => {
    let { localPaths } = filterAssets(args.assets, -1, false, false, true);
    NativeActionUtil.runExecQuery(localPaths, 'reveal');
  },
  onEdit: (event, args) => {
    let { localPaths } = filterAssets(args.assets, -1, false, false, true);
    NativeActionUtil.runExecQuery(localPaths, 'open');
  },
  onDownload: (event, args) => {
    window.gs.selectedAssets = args.assets;
    window.gs.isDownloadClick = true;
    if (ViewUtil.isSeachTabActive()) {
      setBackToSrchBtn(BACK_TO_BTN.ADVANCED_SRCH)
    }
    ViewUtil.switchToAssetDetailView(window.gs.selectedAssets[0]._fuid, true);
  },
  onResurrect: (event, args) => {
    const assets = args.assets
    let { remotePaths } = filterAssets(assets, 0, true);
    if (remotePaths && remotePaths.length > 0) {
      new ResurrectQuery(args.getProgressOnQuery).run(assets, remotePaths);
    }
  },
  onRunDelinkQuery: (event, args) => {
    new GetdelinkQuery(args.assets, args.getProgressOnQuery).run();
  },
  onOpen: (event, args) => {
    const asset = args.assets[0]
    const extInfo = asset.extraInfo;
    if (extInfo && extInfo.isIsConnected()) {
      NativeActionUtil.runExecQuery([extInfo.getDragPath()], 'open');
    } else {
      const checkoutController = new CheckoutController(args.assets, false, false, null, 'open');
      checkoutController.run();
    }
  },
  onLock: (event, args) => {
    const assets = args.assets;
    let { remotePaths } = filterAssets(assets, -1, true);
    new LockQuery(args.getProgressOnQuery).run(remotePaths, assets);
  },

  onUnLock: (event, args) => {
    const assets = args.assets;
    let { assetIds } = filterAssets(assets, -1, false, true);
    new UnLockQuery(args.getProgressOnQuery).run(assetIds, assets[0].getRemotePath(), assets);
  },

  onAddOrRemoveFromFavorite: (event, args) => {
    const asset = args.assets[0];
    const isFav = FileInfoUtil.isFavAsset(asset.getFuid());
    isFav ? removeFavItem(asset) : favAddRemoveOperation(asset);
  },
  onCleanUpLowRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      false,
      false,
      true,
      false,
      assetIds,
      null,
      'Global',
      false
    );
    query.run(onRefreshPWD);
  },
  onCleanUpMidRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      false,
      true,
      false,
      false,
      assetIds,
      null,
      'Global',
      false
    );
    query.run(onRefreshPWD);
  },
  onCleanUpHiRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      true,
      false,
      false,
      false,
      assetIds,
      null,
      'Global',
      false
    );
    query.run(onRefreshPWD);
  },
  onArchiveLowResAndDirect: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      false,
      false,
      true,
      true,
      assetIds,
      null,
      'Global',
      true
    );
    query.run(onRefreshPWD);
  },
  onArchiveMidRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      false,
      true,
      false,
      false,
      assetIds,
      null,
      'Global',
      true
    );
    query.run(onRefreshPWD);
  },
  onArchiveHiRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      true,
      false,
      false,
      false,
      assetIds,
      null,
      'Global',
      true
    );
    query.run(onRefreshPWD);
  },
  onRestoreLowResAndDirect: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      false,
      false,
      true,
      true,
      assetIds
    );
    query.run(onRefreshPWD);
  },
  onRestoreMidRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      false,
      true,
      false,
      false,
      assetIds
    );
    query.run(onRefreshPWD);
  },
  onRestoreHiRes: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      true,
      false,
      false,
      false,
      assetIds
    );
    query.run(onRefreshPWD);
  },
  onCopyLowResFromBackupToS3: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      false,
      false,
      true,
      false,
      assetIds,
      true
    );
    query.run(onRefreshPWD);
  },
  onCopyMidResFromBackupToS3: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      false,
      true,
      false,
      false,
      assetIds,
      true
    );
    query.run(onRefreshPWD);
  },
  onCopyHiResFromBackupToS3: (event, args) => {
    const { assets, onRefreshPWD } = args;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      true,
      false,
      false,
      false,
      assetIds,
      true
    );
    query.run(onRefreshPWD);
  },

  renameCollection: (args) => {
    console.log(args);
    let newName = args[0];
    let collection = args[1];
    if (newName && CollectionUtil.getCollectionName(collection) !== newName) {
      CollectionUtil.renameCollection(collection, newName).then(
        (success) => {
          if (success) {
            args[2]();
            collection.setName(newName);
            ViewUtil.setTitle();
            toast(t('RENAME_SUCCESS'));
            treeEmitter.emit('refreshNodes', [collection.getParentId() > 0 ? collection.getParentId() : CollectionUtil.ROOT_COLLECTION_ID]);
            window.render();
          }
        },
        (errorId) => {
          args[2]();
          ErrorHandler.handleError(errorId);
          collection.setName(CollectionUtil.getCollectionName(collection));
          window.render();
        }
      );
    } else {
      // args[2]();
      toast(t('RENAME_FAILED'));

    }
  },
  onRemoveFromBin: (event, args) => {
    let { collection, selectedCollections } = args;
    if (!collection) {
      collection = selectedCollections && selectedCollections.length ? selectedCollections[0] : null;
    }
    if (collection) {
      CollectionUtil.editCollectionParent(collection, -1)
        .then(async success => {
          if (success) {
            let collectionTreeIdsToRefresh = collection.getParentId() > 0 ? [collection.getParentId(), CollectionUtil.ROOT_COLLECTION_ID] : [CollectionUtil.ROOT_COLLECTION_ID];
            await CollectionUtil.loadCollectionsInView(collection.getParentId());
            treeEmitter.emit('refreshNodes', collectionTreeIdsToRefresh);
            toast(t('REMOVED_SUCCESSFULLY'));
          }
          else {
            toast(t('UNKNOWN_ERROR'));
          }
        })
        .catch(error => {
          console.log(error);
          if (error.errorDetails && error.errorDetails.length > 0) toast(error.errorDetails);
          else toast(error.statusText);
        });
    }
  },
  onReactivateBin: async (event, args) => {
    const { DUE_DATE } = CollectionUtil.COLLECTION_PARAM_KEYS;
    const { collection, selectedCollections } = args;
    const cid = selectedCollections && selectedCollections[0] ? selectedCollections[0].getCollectionId() : collection.getCollectionId();
    await CollectionUtil.deleteMetadata(cid, DUE_DATE);
    await CollectionUtil.deleteMetadata(collection.getCollectionId(), DUE_DATE);
    reloadCollection();
    toast(t('COLLECTION_REACTIVATED'));
  },
  onReactivateCollection: async (event, args) => {
    const { DUE_DATE } = CollectionUtil.COLLECTION_PARAM_KEYS;
    const { collection, selectedCollections } = args;
    const cid = selectedCollections && selectedCollections[0] ? selectedCollections[0].getCollectionId() : collection.getCollectionId();
    await CollectionUtil.deleteMetadata(cid, DUE_DATE);
    reloadCollection();
    toast(t('COLLECTION_REACTIVATED'));
  },
  onCollectionAssetDownload: (event, args) => {
    const { assets } = args;
    CollectionUtil.downloadAsset(assets[0]);
  }
}